<template>
  <el-dialog
    :visible.sync="isShow"
    width="80%"
    custom-class="preview-all-form-box"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :close-on-press-escape="false"
    :show-close="false"
    top="5vh"
  >
    <div slot="title" class="header-title color">{{t('ai.aiAnalysisResults')}}</div>
    <div class='preview word-wrap'>
      <!-- 专业资格 -->
      <el-collapse v-model="activeNames">
        <!-- <el-collapse-item name="studentQualificationDtos">
          <div class="preview-content-title" slot="title">
            {{t('stuManagement.profQual')}}
          </div>
          <div class="preview-content-box">
            <div class="preview-content-item" v-for="(item,index) in studentQualificationDtos" :key="index">
              <div class="content-title">
                <div class="line"></div>
                <div class="color">{{t('stuManagement.profQual')}} {{index+1}}</div>
              </div>
              <el-row :gutter="10" class="content-text">
                <el-col :span="8" :xs="24" v-for="dataItem in item" :key="dataItem.prop">
                  <div class="content-label">{{dataItem.label}}</div>
                  <div class="content-value">{{dataItem.value}}</div>
                </el-col>
              </el-row>
            </div>
            <p v-show="!studentQualificationDtos.length" class="noData"></p>
          </div>
        </el-collapse-item> -->
        <el-collapse-item name="studentWorkDtos">
          <!-- 工作经验 -->
          <div class="preview-content-title" slot="title">
            {{t('stuManagement.experience')}}
          </div>
          <div class="preview-content-box">
            <div class="preview-content-item" v-for="(item,index) in studentWorkDtos" :key="index">
              <div class="content-title">
                <div class="line"></div>
                <div class="color">{{t('stuManagement.experience')}} {{index+1}}</div>
              </div>
              <el-row :gutter="10" class="content-text">
                <el-col :span="8" :xs="24" v-for="dataItem in item" :key="dataItem.prop">
                  <div class="content-label">{{dataItem.label}}</div>
                  <div class="content-value">{{dataItem.value}}</div>
                </el-col>
              </el-row>
            </div>
            <p v-show="!studentWorkDtos.length" class="noData"></p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="studentEducationDtos">
          <!-- 教育背景 -->
          <div class="preview-content-title" slot="title">
            {{t('stuManagement.eduBackground')}}
          </div>
          <div class="preview-content-box">
            <div class="preview-content-item" v-for="(item,index) in studentEducationDtos" :key="index">
              <div class="content-title">
                <div class="line"></div>
                <div class="color">{{t('stuManagement.eduBackground')}} {{index+1}}</div>
              </div>
              <el-row :gutter="10" class="content-text">
                <el-col :span="8" :xs="24" v-for="dataItem in item" :key="dataItem.prop">
                  <div class="content-label">{{dataItem.label}}</div>
                  <div class="content-value">{{dataItem.value}}</div>
                </el-col>
              </el-row>
            </div>
            <p v-show="!studentEducationDtos.length" class="noData"></p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="studentReferenceDtos">
          <!-- 推荐人 -->
          <div class="preview-content-title" slot="title">
            {{t('stuManagement.referee')}}
          </div>
          <div class="preview-content-box">
            <div class="preview-content-item" v-for="(item,index) in studentReferenceDtos" :key="index">
              <div class="content-title">
                <div class="line"></div>
                <div class="color">{{t('stuManagement.referee')}} {{index+1}}</div>
              </div>
              <el-row :gutter="10" class="content-text">
                <el-col :span="8" :xs="24" v-for="dataItem in item" :key="dataItem.prop">
                  <div class="content-label">{{dataItem.label}}</div>
                  <div class="content-value">{{dataItem.value}}</div>
                </el-col>
              </el-row>
            </div>
            <p v-show="!studentReferenceDtos.length" class="noData"></p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="studentScoreDtos">
          <!-- 语言成绩 -->
          <div class="preview-content-title" slot="title">
            {{t('stuManagement.examination')}}
          </div>
          <div class="preview-content-box">
            <div class="preview-content-item" v-for="(item,index) in studentScoreDtos" :key="index">
              <div class="content-title">
                <div class="line"></div>
                <div class="color">{{t('stuManagement.examination')}} {{index+1}}</div>
              </div>
              <el-row :gutter="10" class="content-text">
                <el-col :span="8" :xs="24" v-for="dataItem in item" :key="dataItem.prop">
                  <div class="content-label">{{dataItem.label}}</div>
                  <div class="content-value">{{dataItem.value}}</div>
                </el-col>
              </el-row>
            </div>
            <p v-show="!studentScoreDtos.length" class="noData"></p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleOverwrite" :loading="loading" type="primary" size="small">
        {{t('ai.oneClickOverwrite')}}
      </el-button>
      <el-button @click="handleCancel" size="small">
        {{t('common.cancel')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from "@/locale/index";
import {saveAiRecordApplyFormApi} from '@/api/common.js'
export default {
  inject: ['hideSubmitBtn','formType'],
  mixins: [i18n],
  tickTime: '',
  data(){
    return {
      image:{
        ai:require('@/assets/ai-upload/AI.png'),
      },
      allData:{},
      isShow:false,
      studentQualificationDtos:[],// 专业资格
      studentWorkDtos:[],// 工作经验
      studentEducationDtos:[],// 教育背景
      studentReferenceDtos:[],// 推荐人
      studentScoreDtos:[],// 语言成绩
      activeNames:[],
      loading:false,
    }
  },
  props:{
    aiAllData:{
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch:{
    isShow:{
      handler(){
        if(this.isShow){
          this.allData=JSON.parse(JSON.stringify(this.aiAllData));
          // 工作经验
          this.setStudentWorkDtos();
          // 教育背景
          this.setStudentEducationDtos();
          // 推荐人
          this.setStudentReferenceDtos();
          // 语言成绩
          this.setStudentScoreDtos();
        }else{
          this.allData={};
          this.activeNames=[];
          this.studentQualificationDtos=[];
          this.studentWorkDtos=[];
          this.studentEducationDtos=[];
          this.studentReferenceDtos=[];
          this.studentScoreDtos=[];
        }
      }
    }
  },
  methods:{
    // 工作经验
    setStudentWorkDtos(){
      this.studentWorkDtos=[];
      if(this.allData.studentWorkDtos&&this.allData.studentWorkDtos.length){
        this.activeNames.push('studentWorkDtos')
        const valueList=[
          {prop:'position',label:this.t('stuManagement.position')},{prop:'workStartDate',label:this.t('stuManagement.workStartTime')},
          {prop:'workEndDate',label:this.t('stuManagement.workEndTime')},{prop:'fkStudentAppCountryName',label:this.t('stuManagement.countryOranisation')},
          {prop:'fkAreaStateName',label:this.t('stuManagement.stateOranisation')},{prop:'fkAreaCityName',label:this.t('stuManagement.cityOranisation')},
          {prop:'companyName',label:this.t('stuManagement.companyName')},{prop:'isOnDuty',label:this.t('stuManagement.isOnDuty')},
          {prop:'workMode',label:this.t('stuManagement.workMode')},{prop:'jobDescription',label:this.t('stuManagement.duties')},
        ]
        this.studentWorkDtos=this.setData(this.allData.studentWorkDtos,valueList)
      }
    },
    // 教育背景
    setStudentEducationDtos(){
      this.studentEducationDtos=[];
      if(this.allData.studentEducationDtos&&this.allData.studentEducationDtos.length){
        this.activeNames.push('studentEducationDtos')
        const valueList=[
          {prop:'educationName',label:this.t('stuManagement.educationType')},{prop:'fkInstitutionNameEn',label:this.t('stuManagement.institution')},
          {prop:'fkStudentAppCountryName',label:this.t('stuManagement.courseCountry')},{prop:'fkAreaRegionName',label:this.t('stuManagement.fkAreaRegion')},
          {prop:'fkAreaStateName',label:this.t('stuManagement.state')},{prop:'fkAreaCityName',label:this.t('stuManagement.city')},
          {prop:'institutionAddress',label:this.t('stuManagement.institutionAddress')},{prop:'fkEducationLevelTypeName',label:this.t('stuManagement.qualification')},
          {prop:'scoreTypeName',label:this.t('stuManagement.gradeCategory')},{prop:'scoreValue',label:this.t('stuManagement.scoreValue')},
          {prop:'major',label:this.t('stuManagement.major')},{prop:'instructedInEng',label:this.t('stuManagement.instructedInEng')},
          {prop:'studyStartDate',label:`${this.t('stuManagement.inschoolTime')}${this.t('common.startDate')}`},
          {prop:'studyEndDate',label:`${this.t('stuManagement.inschoolTime')}${this.t('common.endDate')}`},
          {prop:'isShouldCompleted',label:this.t('stuManagement.isWillComplated')},{prop:'isCompleted',label:this.t('stuManagement.isComplated')},
        ]
        this.studentEducationDtos=this.setData(this.allData.studentEducationDtos,valueList,'educationDto')
      }
    },
    // 推荐人
    setStudentReferenceDtos(){
      this.studentReferenceDtos=[];
      if(this.allData.studentReferenceDtos&&this.allData.studentReferenceDtos.length){
        this.activeNames.push('studentReferenceDtos')
        const valueList=[
          {prop:'lastName',label:this.t('stuManagement.surname')},{prop:'firstName',label:this.t('stuManagement.givenName')},
          {prop:'title',label:this.t('stuManagement.title')},{prop:'company',label:this.t('stuManagement.instituCompany')},
          {prop:'position',label:this.t('stuManagement.position')},{prop:'email',label:this.t('stuManagement.email')},
          {prop:'phoneNumber',label:this.t('stuManagement.phoneNumber')},{prop:'fkStudentAppCountryName',label:this.t('stuManagement.refereeCountry')},
          {prop:'fkAreaStateName',label:this.t('stuManagement.state')},{prop:'fkAreaCityName',label:this.t('stuManagement.city')},
          {prop:'contactAddress1',label:this.t('stuManagement.contactAddress1')},{prop:'contactAddress2',label:this.t('stuManagement.contactAddress2')},
          {prop:'contactPostcode',label:this.t('stuManagement.postcode')},
        ]
        this.studentReferenceDtos=this.setData(this.allData.studentReferenceDtos,valueList)
      }
    },
    // 语言成绩
    setStudentScoreDtos(){
      this.studentScoreDtos=[];
      if(this.allData.studentScoreDtos&&this.allData.studentScoreDtos.length){
        this.activeNames.push('studentScoreDtos')
        const valueList=[
          {prop:'examTypeName',label:this.t('languageInfo.examType')},{prop:'isUkviIeltsName',label:this.t('languageInfo.isUkviIelts')},
          {prop:'ukviNumber',label:this.t('languageInfo.ukviNumber')},{prop:'examListen',label:this.t('languageInfo.examListen')},
          {prop:'examRead',label:this.t('languageInfo.examRead')},{prop:'examWrite',label:this.t('languageInfo.examWrite')},
          {prop:'examSpeak',label:this.t('languageInfo.examSpeak')},{prop:'examTotal',label:this.t('languageInfo.examTotal')},
          {prop:'examinationCheckAccount',label:this.t('languageInfo.examinationCheckAccount')},{prop:'testCenterNumber',label:this.t('languageInfo.testCenterNumber')},
          {prop:'examinationDate',label:this.t('languageInfo.examinationDate')},{prop:'examinationNumber',label:this.t('languageInfo.testTakerId')},
          {prop:'fkStudentAppCountryName',label:this.t('languageInfo.fkStudentAppCountryId')},{prop:'isReexamination',label:this.t('languageInfo.isReexamination')},
          {prop:'reexaminationDate',label:this.t('languageInfo.reexaminationDate')},
        ]
        this.studentScoreDtos=this.setData(this.allData.studentScoreDtos,valueList,'scoreDtos')
      }
    },
    // 设置值
    setData(dtos,valueList,type){
      const reqList=[];
      if(type==='educationDto'){
        dtos=this.adjustmentEducationDtos(dtos);
      }else if(type==='scoreDtos'){
        dtos=this.adjustmentScoreDtos(dtos);
      }
      for(const item of dtos){
        const itemList=JSON.parse(JSON.stringify(valueList));
        for(const valueItem of itemList){
          // 插入显示值
          valueItem['value']=item[valueItem.prop]?item[valueItem.prop]:'-'
        }
        reqList.push(itemList)
      }
      return reqList
    },
    // 调整值内容
    // 雅思
    adjustmentScoreDtos(dtos){
      const reqDtos=dtos;
      for(const item of reqDtos){
        this.$set(item,'isUkviIeltsName','');
        if(item.isUkviIelts){
          item.isUkviIeltsName=this.t('common.yes');
        }else{
          item.isUkviIeltsName=this.t('common.no');
        }
      }
      return reqDtos
    },
    // 教育背景
    adjustmentEducationDtos(dtos){
      const reqDtos=dtos;
      const levelOption=['K-12',this.t("stuManagement.highSchool"),this.t("stuManagement.higherEducation")
      ];
      for(const item of reqDtos){
        this.$set(item,'educationName','');
        if(item.educationType===0||item.educationType===1||item.educationType===2){
          item.educationName=levelOption[item.educationType];
        }
      }
      return reqDtos
    },
    // 一键覆盖
    async handleOverwrite(){
      this.loading=false;
      this.$confIssue(this.t('ai.oneClickOverwriteTips'),this.t('common.tip'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.t("common.confirm"),
        cancelButtonText: this.t("common.cancel"),
      }).then(async ()=>{
        this.loading=true;
        try{
          const {data}=await saveAiRecordApplyFormApi(this.allData);
          if(data.code==='1003'){
            if(data.data.isSuccess&&!data.data.errorMsg){
              this.$msge({
                message:this.t('ai.overwriteSuccessful'),
                type: "success",
              });
              this.loading=false;
              this.$emit('handleOverwrite');
              this.handleCancel();
            }else{
              const errorList=data.data.errorMsg;
              let msg=`<p style="color:#00a854">${this.t('ai.overwriteSuccessful')}</p>`;
              msg+=`<p style="color:red">${this.t('ai.oneClickOverwriteTips2')}</p>` 
              const errorKey={
                WORK:this.t('stuManagement.experience'),
                REFERENCE_LETTER:this.t('stuManagement.referee'),
                CV:this.t('stuManagement.eduBackground'),
                SCORE:this.t('stuManagement.examination')
              }
              for(const item of errorList){
                if(errorKey[item.key]){
                  msg+=`<p style="color:red">- ${errorKey[item.key]}</p>` 
                }else{
                  msg+=`<p style="color:red">- ${item.value}</p>` 
                }
              }
              this.$alrt(msg, this.t('common.tip'), {
                confirmButtonText: this.t('common.confirm'),
                dangerouslyUseHTMLString:true,
                callback: () => {
                  this.loading=false;
                  this.$emit('handleOverwrite');
                  this.handleCancel();
                },
              });
            }
          }else{
            this.loading=false;
            this.$msge({
              message:this.t('ai.overwriteFailure'),
              type: "error",
            });
          }
        }catch(err){
          this.$msge({
            message:this.t('ai.overwriteFailure'),
            type: "error",
          });
          this.loading=false;
        }
      })
    },
    handleCancel(){
      this.isShow=false;
    }
  }
}
</script>
<style  lang='scss'>
.preview-all-form-box{
  .el-dialog__body{
    padding-top:0;
    height:75vh;
    overflow: auto;
  }
  .el-dialog__footer{
    text-align: center;
    padding: 10px;
    border:1px solid #EEE
  }
}
</style>
<style lang='scss' scoped>
.flex{
  display: flex;
  align-items:center;
}
.color{
  color: #FF9600;
}
.header-title{
  font-weight: bold;
  font-size: 18px;
}
.preview{
  padding:12px 16px;
  border-radius: 10px;
  .preview-content-title{
    padding: 16px 16px 16px 0;
    text-align: left;
    font-size: 18px;
    color: #333;
    font-weight: 600;
  }
  .preview-content-box{
    text-align: left;
    padding:0 16px;
    .content-title{
      display: flex;
      height: 34px;
      padding: 0px 10px;
      align-items: center;
      border-radius: 4px;
      background: #FFF6E9;
      .line{
        width: 3px;
        height: 13px;
        background: #FF9600;
        margin-right:8px;
      }
    }
    .content-text{
      padding:10px 0;
      display: flex;
      flex-wrap: wrap;
      .content-label{
        color: #999;
      }
      .content-value{
        color: #333;
        padding:10px 0;
        min-height:35px;
      }
    }
  }
  .noData{
    width:120px;
    height:120px;
    background: url('../../../src/assets/ai-upload/noData.png') no-repeat;
    background-size: cover;
    margin:0 auto;
  }
}
.word-wrap{
  word-break: break-all;
  word-break: break-word;
}
</style>